import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import ReportGateway from '~apis/report';
import UtilFunctions from '~utils/functions';
import { FundTypeEnum } from '~utils/enums';

export default function* watchGetInventoryReportCardSummary(api: ReportGateway): SagaWatcherReturnType {
    yield takeEvery('report/reportGetInventoryReportCardSummaryAttempt', handleGetInventoryReportCardSummary, api);
}

function* handleGetInventoryReportCardSummary(api: ReportGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { fundType } = reduxState.report.inventoryReport.inventoryReportFiltersSummary;

    const response = yield* call([api, api.getInventoryReportCardSummary], {
        authToken,
        fundType,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.reportGetInventoryReportCardSummaryFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.reportGetInventoryReportCardSummarySuccess(response.data));
    }
}
